import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_ecomsync_item_syncing_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.TextDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    ecomsync_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    mkt_guid: fromDatatype.GuidDataFieldInterface;
    event_code: fromDatatype.VarcharDatatypeInterface;
    event_properties: fromDatatype.JsonDatatypeInterface;
    execution_after: fromDatatype.TimestampTzDatatypeInterface;
    execution_expiry: fromDatatype.TimestampTzDatatypeInterface;
    number_of_retry: fromDatatype.NumericDatatypeInterface;
    max_retry: fromDatatype.NumericDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_mst_ecomsync_item_syncing_queue_RowClass implements bl_fi_mst_ecomsync_item_syncing_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.TextDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    ecomsync_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    mkt_guid: fromDatatype.GuidDataFieldInterface;
    event_code: fromDatatype.VarcharDatatypeInterface;
    event_properties: fromDatatype.JsonDatatypeInterface;
    execution_after: fromDatatype.TimestampTzDatatypeInterface;
    execution_expiry: fromDatatype.TimestampTzDatatypeInterface;
    number_of_retry: fromDatatype.NumericDatatypeInterface;
    max_retry: fromDatatype.NumericDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  
}
